import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTooltip,{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c(VIcon,_vm._g({staticClass:"mr-2",attrs:{"small":"","disabled":_vm.disabled,"color":_vm.localColor},on:{"click":function($event){_vm.localValue = !_vm.localValue}}},on),[_vm._v(_vm._s(_vm.icon)+"\n    ")])]}}])},[_c('span',[_vm._v(_vm._s(this.toolTip))])])
}
var staticRenderFns = []

export { render, staticRenderFns }